import {
  Mark,
  markInputRule,
  markPasteRule,
  mergeAttributes,
} from '@tiptap/core';

const HASHTAG_INPUT_REGEX = /(?:^|\s)(#[\w]+)\s$/;
const HASHTAG_PASTE_REGEX = /(?:^|\s)(#[\w]+)/g;

export const Hashtag = Mark.create({
  name: 'hashtag',
  inclusive: false,

  parseHTML() {
    return [{ tag: 'span[data-type="hashtag"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(HTMLAttributes, {
        'data-type': 'hashtag',
        class: 'text-pink-accent',
      }),
      0,
    ];
  },

  addInputRules() {
    return [
      markInputRule({
        find: HASHTAG_INPUT_REGEX,
        type: this.type,
      }),
    ];
  },

  addPasteRules() {
    return [
      markPasteRule({
        find: HASHTAG_PASTE_REGEX,
        type: this.type,
      }),
    ];
  },
});
